import React, { useState, useEffect } from 'react';
import { useTimezone } from '../../store/slices/commonSlice';

const CurrentTime = () => {
  const timezone = useTimezone();
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: timezone
      }).format(new Date());

      setCurrentTime(formattedDate);
    }, 1000);

    return () => clearInterval(interval);
  }, [timezone]);

  return <div className="text-center text-primary fs-6">{currentTime}</div>;
};

export default CurrentTime;
